/**
 * The Charge Journey — five site chapters (slides).
 * Labels use English i18n keys from language packs.
 */
export const CHAPTERS = [
  {
    id: "hero",
    targetId: "hero",
    labelKey: "Flash",
    short: "01",
  },
  {
    id: "ecosystem",
    targetId: "services",
    labelKey: "Our Services",
    short: "02",
  },
  {
    id: "launch",
    targetId: "roadmap",
    labelKey: "Tokenomics",
    short: "03",
  },
  {
    id: "trust",
    targetId: "team",
    labelKey: "Team",
    short: "04",
  },
  {
    id: "connect",
    targetId: "Contact",
    labelKey: "Contact",
    short: "05",
  },
];

/** Visual / motion multipliers for the floating coin per chapter. */
export const CHAPTER_COIN_STYLE = {
  // xBias 0 — spawn stays top-left; path X_STOPS handles the journey.
  hero: { scale: 1.05, opacity: 0.95, xBias: 0 },
  ecosystem: { scale: 0.92, opacity: 0.88, xBias: -0.04 },
  launch: { scale: 1.08, opacity: 1, xBias: 0 },
  trust: { scale: 0.78, opacity: 0.72, xBias: 0.06 },
  connect: { scale: 0.7, opacity: 0.55, xBias: -0.02 },
};

export function getChapterById(id) {
  return CHAPTERS.find((c) => c.id === id) || CHAPTERS[0];
}
